import { render, staticRenderFns } from "./Errore.vue?vue&type=template&id=0476da4e&"
import script from "./Errore.vue?vue&type=script&lang=js&"
export * from "./Errore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports